import React, { useState, useEffect } from 'react';
import { Users, Edit2, Check, X } from 'lucide-react';

const ManageClients = ({ templates }) => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({});

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    try {
      const res = await fetch('/api/client/list');
      const data = await res.json();
      setClients(data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const updateTemplate = async (clientId, templateId) => {
    try {
      await fetch('/api/client/update-template', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ clientId, templateId: parseInt(templateId) })
      });
      fetchClients();
    } catch (err) {
      alert('Failed to update template.');
    }
  };

  const startEdit = (client) => {
    setEditingId(client.Id || client.id);
    setEditForm({
      id: client.Id || client.id,
      companyName: client.CompanyName || client.companyName || '',
      address: client.Address || client.address || '',
      contact: client.Contact || client.contact || '',
      gstin: client.GSTIN || client.gstin || '',
      logoUrl: client.LogoUrl || client.logoUrl || ''
    });
  };

  const cancelEdit = () => setEditingId(null);

  const saveEdit = async () => {
    try {
      await fetch('/api/client/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(editForm)
      });
      setEditingId(null);
      fetchClients();
    } catch (err) {
      alert('Failed to save Client info.');
    }
  };

  return (
    <div className="form-section animate-fade-in">
      <h3 className="section-title" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <Users size={20} className="text-primary"/> Client Management
      </h3>
      
      {loading ? (
        <div style={{ textAlign: 'center', padding: '3rem' }}>Loading clients...</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table className="premium-table">
            <thead>
              <tr>
                <th>Company Name</th>
                <th>Address & Contact</th>
                <th>GSTIN</th>
                <th>Logo URL</th>
                <th>Template</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {clients.map(client => {
                const isEditing = editingId === (client.Id || client.id);

                if (isEditing) {
                  return (
                    <tr key={client.Id || client.id} style={{ background: '#f8fafc' }}>
                      <td>
                        <input className="table-input" value={editForm.companyName} onChange={e => setEditForm({...editForm, companyName: e.target.value})} placeholder="Company" />
                      </td>
                      <td>
                        <textarea className="table-input" rows="2" value={editForm.address} onChange={e => setEditForm({...editForm, address: e.target.value})} placeholder="Address"></textarea>
                        <input className="table-input" style={{ marginTop: '0.5rem' }} value={editForm.contact} onChange={e => setEditForm({...editForm, contact: e.target.value})} placeholder="Contact" />
                      </td>
                      <td>
                        <input className="table-input" value={editForm.gstin} onChange={e => setEditForm({...editForm, gstin: e.target.value})} placeholder="GSTIN" />
                      </td>
                      <td>
                        <input className="table-input" value={editForm.logoUrl} onChange={e => setEditForm({...editForm, logoUrl: e.target.value})} placeholder="https://..." />
                      </td>
                      <td>--</td>
                      <td>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                          <button onClick={saveEdit} style={{ background: 'var(--secondary)', color: 'white', padding: '0.4rem', border: 'none', borderRadius: '4px', cursor: 'pointer' }}><Check size={16}/></button>
                          <button onClick={cancelEdit} style={{ background: 'var(--danger)', color: 'white', padding: '0.4rem', border: 'none', borderRadius: '4px', cursor: 'pointer' }}><X size={16}/></button>
                        </div>
                      </td>
                    </tr>
                  )
                }

                return (
                  <tr key={client.Id || client.id}>
                    <td style={{ fontWeight: '500', color: 'var(--text-dark)' }}>{client.CompanyName || client.companyName}</td>
                    <td>
                      <div style={{ fontSize: '0.8rem' }}>{client.Address || client.address}</div>
                      <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>{client.Contact || client.contact}</div>
                    </td>
                    <td>{client.GSTIN || client.gstin}</td>
                    <td>{client.LogoUrl || client.logoUrl ? <a href={client.LogoUrl || client.logoUrl} target="_blank" rel="noreferrer" style={{ fontSize: '0.8rem', color: 'var(--primary)' }}>View Logo</a> : 'None'}</td>
                    <td>
                      <select 
                        className="premium-input" 
                        style={{ width: 'auto', padding: '0.5rem' }} 
                        value={client.PreferredTemplateId || client.preferredTemplateId || 1}
                        onChange={(e) => updateTemplate(client.Id || client.id, e.target.value)}
                      >
                        {templates.map(t => (
                          <option key={t.Id || t.id} value={t.Id || t.id}>{t.Name || t.name}</option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <button onClick={() => startEdit(client)} className="btn-outline" style={{ padding: '0.4rem', border: 'none' }}><Edit2 size={16}/></button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ManageClients;
